import { createContext } from 'react';
const AuthContext = /*#__PURE__*/createContext({
  gates: [],
  user: {},
  portal: {}
});
export default AuthContext;